import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';

function Home() {
  const [conversionType, setConversionType] = useState('');
  const navigate = useNavigate();

  const handleCardClick = (type) => {
    setConversionType(type);
    navigate(`/convert/${type}`);
  };

  const handleBuyAirtimeClick = () => {
    navigate('/buy-airtime');
  };

  return (
    <div className="home">
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1>Convert Kredo to Cash in Seconds!</h1>
            <p>Sokoni helps you convert your Safaricom, Airtel & Telkom credit & Bonga Points to M-pesa instantly</p>
          </div>
        </div>
      </section>

      <section className="conversion-section">
        <div className="container">
          <h2 className="section-title">Choose Your Conversion Option</h2>
          
          <div className="conversion-options">
            <div 
              className={`option ${conversionType === 'safaricom' ? 'active' : ''}`} 
              onClick={() => handleCardClick('safaricom')}
            >
              <div className="option-logo safaricom-logo"></div>
              <h3>CONVERT SAFARICOM AIRTIME TO CASH</h3>
              <p>Swap your Safaricom Airtime for M-pesa at ~ 90.00% rate.</p>
            </div>
            
            <div 
              className={`option ${conversionType === 'airtel' ? 'active' : ''}`}
              onClick={() => handleCardClick('airtel')}
            >
              <div className="option-logo airtel-logo"></div>
              <h3>CONVERT AIRTEL AIRTIME TO CASH</h3>
              <p>Swap your Airtel Airtime for M-pesa at ~ 80.00% rate.</p>
            </div>
            
            <div 
              className={`option ${conversionType === 'bonga' ? 'active' : ''}`}
              onClick={() => handleCardClick('bonga')}
            >
              <div className="option-logo bonga-logo"></div>
              <h3>CONVERT BONGA POINTS TO CASH</h3>
              <p>Swap your Bonga points for M-pesa at 60%</p>
            </div>
          </div>
          
          <div className="buy-airtime-button-container">
            <button 
              className="buy-airtime-button"
              onClick={handleBuyAirtimeClick}
            >
              Buy Cheap Airtime
            </button>
          </div>
        </div>
      </section>

      <section className="about">
        <div className="container">
          <h2>About Sokoni</h2>
          <p>
            Sokoni helps you convert your Safaricom & Airtel airtime and Bonga Points to Money instantly.
            We also sell discounted Safaricom, Airtel and Telkom airtime. We offer the best rates in the market.
            Our systems are automated, guaranteeing you speed and reliability.
          </p>
        </div>
      </section>

      <section className="why-us">
        <div className="container">
          <h2>Why Sokoni</h2>
          <div className="features">
            <div className="feature">
              <div className="feature-icon">✓</div>
              <div className="feature-text">Top rates</div>
            </div>
            <div className="feature">
              <div className="feature-icon">✓</div>
              <div className="feature-text">Reliable</div>
            </div>
            <div className="feature">
              <div className="feature-icon">✓</div>
              <div className="feature-text">Automated - Available 24/7</div>
            </div>
            <div className="feature">
              <div className="feature-icon">✓</div>
              <div className="feature-text">No transaction fees</div>
            </div>
            <div className="feature">
              <div className="feature-icon">✓</div>
              <div className="feature-text">Fast</div>
            </div>
          </div>
        </div>
      </section>

      <section className="faqs">
        <div className="container">
          <h2>FAQs</h2>
          <div className="faq-list">
            <div className="faq-item">
              <h3>Is the airtime to M-pesa conversion a Safaricom product or Service?</h3>
              <p>No, airtime to M-pesa conversion is an independent service offered by Sokoni and has no relationship with Safaricom PLC whatsoever.</p>
            </div>
            <div className="faq-item">
              <h3>How long does it take to receive Money after I Sambaza my airtime to Sokoni?</h3>
              <p>Money transfer is immediate, unless there are delays affecting the M-pesa service.</p>
            </div>
            <div className="faq-item">
              <h3>What is the minimum and maximum value of airtime that you can convert?</h3>
              <p>The minimum value of airtime that you can convert is Ksh. 30 while the maximum is Ksh. 10,000. Consider multiple transactions in case of amounts above Ksh. 10,000.</p>

	  <h3>What are the most common sources of excess credit?</h3>      <p>Credit bought from bank or mobile money accidentally, extra airtime from work, credit won on radio and TV shows, gift airtime etc</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
